import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the pathname changes.
 * The fixed header (h-20 = 80px) is already offset by `pt-20` on <main>,
 * so a plain scroll to (0,0) puts the destination heading right below the header.
 * Smooth on route changes; instant on refresh.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduce ? "auto" : "smooth" });
  }, [pathname]);
  return null;
}
